import type { CollectionCardConfig } from '@/lib/blocks/collection/blocks';
import { resolveSymmetricGridLayout } from '@/lib/blocks/collection/blocks';
import { cn } from '@/lib/utils';

export function indexCollectionCardShellClassName(hasCardStyling: boolean, className?: string) {
  return cn(
    'rounded-lg',
    hasCardStyling ? 'bg-transparent' : 'border border-border bg-card text-card-foreground',
    className,
  );
}

export type IndexCollectionCardShellProps = {
  hasCardStyling?: boolean;
};

export function resolveIndexCardConfig(
  cardConfig: CollectionCardConfig,
  variantProps: Record<string, unknown>,
): CollectionCardConfig {
  return {
    ...cardConfig,
    gap: resolveSymmetricGridLayout(variantProps).gap,
  };
}
